<template>
    <Question :question="question">
        <div class="form-group">
            <DateInput label="Birthday" v-model="birthday" :required="true"/>            
            <br>
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text">City/State of birth</span>
                </div>
                <input type="text" class="form-control" v-model="placeOfBirth" required>
            </div>            
        </div>
    </Question>
</template>

<script>
import Question from '../Question.vue'
import DateInput from './DateInput.vue'
export default {
  name: 'Birthday',
  props: {
      question: String
  },
  components: {
      Question,
      DateInput
  },
  data: function() {
    return {
        "birthday": "",
        "placeOfBirth": ""
    };
  }
}
</script>